<template>
  <div class="order-container bgc-gradient" style="padding-bottom: 1.2rem">
    <Header :title="headerTitle" :is-nav="true"></Header>
    <SearchBar :keyword="searchForm.keyword" @onSearch="onSearch"></SearchBar>

    <div class="main-container" style="position: static;overflow: auto; flex: 1">
      <van-pull-refresh v-model="loading" @refresh="onRefresh">
        <van-list v-if="orderList.length > 0" v-model="loading" :finished="finished" finished-text="没有更多了" @load="load">
          <TopProductList :searchData="orderList"></TopProductList>
        </van-list>
        <van-empty v-if="dataEmpty" class="custom-empty" description="暂无数据"></van-empty>
      </van-pull-refresh>
    </div>

    <van-popup v-model="filterFlag" :overlay="true" position="right">
      <FilterList :brandList="brandList" @refreshData="refreshData"></FilterList>
    </van-popup>
  </div>
</template>
<script>
import Header from '@/components/Header';
import TopProductList from "../../components/TopProductList";
import SearchBar from "@/components/SearchBar";
import planSaleApi from "@/request/planSaleApi";
import goodsApi from '@/request/goodsApi';

export default {
  name: "Funds",
  components: {
    Header,
    SearchBar,
    TopProductList,
  },
  data() {
    return {
      loading: false,
      finished: false,
      headerTitle: "王牌商品",
      filterFlag: false,
      orderList: [],
      sellers: [],
      brandList: [],
      searchForm: {
        categoryNameLevel1: "",
        categoryNameLevel2: "",
        keyword: "",
        owned: null,
        alive_flag: 1
      },
      infoType: '',
      hasNextPage: true,
      formPage: {
        currentPage: 0,
        pageSize: 10,
      },
    };
  },
  mounted() {
    if (this.$route.query.val) {
      this.onSearch(this.$route.query.val)
    }
    if (this.$route.query.infoType == '09') {
      this.headerTitle = '王牌商品'
    }
    if (this.$route.query.infoType == '11') {
      this.headerTitle = '新商品'
    }
    if (this.$route.query.infoType == '10') {
      this.headerTitle = '新材料'
    }
    if (this.$route.query.infoType == '14') {
      this.headerTitle = '其他商品'
    }

  },
  computed: {
    statusType() {
      return this.$store.state.valueSet.NG_ORDER_STATUS;
    },
    orderType() {
      return this.$store.state.valueSet.NG_ORDER_TYPE;
    },
    dataEmpty() {
      return this.orderList.length == 0 && !this.loading;
    },
  },
  watch: {},
  created() {
    if (this.$route.query.infoType) {
      this.infoType = this.$route.query.infoType
    }
    this.getOrderList();
    this.getBrandList();
  },
  methods: {
    load() {
      this.getOrderList()
    },
    onFilter() {
      this.filterFlag = !this.filterFlag;
    },
    onSearch(val) {
      this.searchForm.keyword = val;
      this.finished = false;
      this.getOrderList();
    },
    onRefresh() {
      this.finished = false;
      this.getOrderList(true);
    },
    refreshData(queryList) {
      this.onFilter();
      let categoryNameLevel1 = "", categoryNameLevel2 = "";
      console.log("000-queryList", queryList);
      queryList.forEach(item => {
        if (item.catagoryLevel == '1') {
          item.list.forEach(it => {
            it.forEach((pi) => {
              if (pi.selected == true) {
                // console.log("pppp===", pi.catagoryName)
                categoryNameLevel1 = pi.catagoryName;
              }
            })
          })
        }
        if (item.catagoryLevel == '2') {
          item.list.forEach(it => {
            it.forEach((pi) => {
              if (pi.selected == true) {
                categoryNameLevel2 = pi.catagoryName;
              }
            })
          })
        }
      })
      this.searchForm.categoryNameLevel1 = categoryNameLevel1;
      this.searchForm.categoryNameLevel2 = categoryNameLevel2;
      this.orderList = [];
      this.formPage.currentPage = 1;
      this.getOrderList();
    },
    async getOrderList(refresh) {
      if (refresh) {
        this.orderList = [];
        this.formPage.currentPage = 1
      } else {
        this.formPage.currentPage = this.formPage.currentPage + 1
      }
      let params = {
        ...this.searchForm,
        ...this.formPage,
        infoType: this.infoType
      }

      this.loading = true;
      goodsApi.queryListByInfoType(params).then((res) => {
        if (res.returnCode == "0") {
          let tempList = res.result.dataList.map(item => {
            item.createTime = item.createTime ? this.$utils.formatDateTime(item.createTime) : "--";
            item.amount = this.$utils.amount(item.amount);
            item.deliveryDateEnd = this.$utils.formatDateTime(item.deliveryDateEnd);
            // item.commodityImage = 
            item.tradeList = []
            return item
          });
          this.orderList = [...this.orderList.concat(tempList)];
          // this.Pagedata.currentPage++;
          this.hasNextPage = res.result.hasNextPage;
          if (!this.hasNextPage) {
            this.finished = true;
          }
        } else {
          this.$toast({
            type: "fail",
            message: res.returnMessage,
            duration: 1500,
          });
        }
      }).finally(() => {
        this.loading = false
      });
    },
    async getBrandList() {
      let params = {};
      this.brandList = [
        {
          name: "大类",
          key: "sellers",
          catagoryLevel: "1",
          multiple: false,
          close: false,
          list: []
        },
        {
          name: "中类",
          catagoryLevel: "2",
          key: "sellers",
          multiple: false,
          close: false,
          list: []
        }
      ];
      planSaleApi.getCategoryTreeData(params).then((res) => {
        if (res.returnCode == "0") {
          this.brandList[0].list.push(res.result);
          res.result.forEach((item) => {
            this.brandList[1].list.push(item.subList);
          })
          console.log("ppppp-list", this.brandList);
        } else {
          this.$toast({
            type: "fail",
            message: res.returnMessage,
            duration: 1500,
          });
        }
      });
    },
  },
};
</script>
<style lang="stylus" scoped>
.order-container {
  // display: flex;
  // flex-direction: column;
  height: 100%;
  position: relative;
  overflow: hidden;
}

.order-container >>> .van-tabs .van-tabs__wrap {
  height: 88px;
}

.order-container >>> .list-wrapper {
  width: 100%;
}

.order-container >>> .van-tabs .van-tabs__wrap .van-tab {
  font-size: 32px;
  line-height: 45px;
  color: #333333;
}

.order-container >>> .van-tabs .van-tabs__wrap .van-tab--active {
  // font-size: 36px;
  color: #E12020;
}

.order-container >>> .van-popup {
  height: 100%;
  width: 576px;
}

.order-container >>> .van-empty__image {
  width: 360px;
  height: 360px;
}

.order-container >>> .van-empty__description {
  font-size: 0.32rem;
  line-height: 0.38rem;
}
</style>